import { render, staticRenderFns } from "./CrawledDocumentsEMPage.vue?vue&type=template&id=3d36d616"
import script from "./CrawledDocumentsEMPage.vue?vue&type=script&lang=js"
export * from "./CrawledDocumentsEMPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports